/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_MenuInputs */

const ja_playdata_nav_menu = /** @type {(inputs: Playdata_Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const en_playdata_nav_menu = /** @type {(inputs: Playdata_Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Playdata_Nav_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_nav_menu = /** @type {((inputs?: Playdata_Nav_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_menu(inputs)
	return en_playdata_nav_menu(inputs)
});